import { render, staticRenderFns } from "./StepBankSelection.vue?vue&type=template&id=23f4c230&scoped=true"
import script from "./StepBankSelection.vue?vue&type=script&lang=js"
export * from "./StepBankSelection.vue?vue&type=script&lang=js"
import style0 from "./StepBankSelection.vue?vue&type=style&index=0&id=23f4c230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4c230",
  null
  
)

export default component.exports